/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationFeatures200Response
 */
export interface GetReservationFeatures200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    manageReservations: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    basicCapacity: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    advancedSettings: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    customNotifications: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    whatsappNotifications: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    customPage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    insurancePolicies: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationFeatures200Response
     */
    analytics: boolean;
}

/**
 * Check if a given object implements the GetReservationFeatures200Response interface.
 */
export function instanceOfGetReservationFeatures200Response(value: object): value is GetReservationFeatures200Response {
    if (!('manageReservations' in value) || value['manageReservations'] === undefined) return false;
    if (!('basicCapacity' in value) || value['basicCapacity'] === undefined) return false;
    if (!('advancedSettings' in value) || value['advancedSettings'] === undefined) return false;
    if (!('customNotifications' in value) || value['customNotifications'] === undefined) return false;
    if (!('whatsappNotifications' in value) || value['whatsappNotifications'] === undefined) return false;
    if (!('customPage' in value) || value['customPage'] === undefined) return false;
    if (!('insurancePolicies' in value) || value['insurancePolicies'] === undefined) return false;
    if (!('analytics' in value) || value['analytics'] === undefined) return false;
    return true;
}

export function GetReservationFeatures200ResponseFromJSON(json: any): GetReservationFeatures200Response {
    return GetReservationFeatures200ResponseFromJSONTyped(json, false);
}

export function GetReservationFeatures200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationFeatures200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'manageReservations': json['manageReservations'],
        'basicCapacity': json['basicCapacity'],
        'advancedSettings': json['advancedSettings'],
        'customNotifications': json['customNotifications'],
        'whatsappNotifications': json['whatsappNotifications'],
        'customPage': json['customPage'],
        'insurancePolicies': json['insurancePolicies'],
        'analytics': json['analytics'],
    };
}

export function GetReservationFeatures200ResponseToJSON(json: any): GetReservationFeatures200Response {
    return GetReservationFeatures200ResponseToJSONTyped(json, false);
}

export function GetReservationFeatures200ResponseToJSONTyped(value?: GetReservationFeatures200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manageReservations': value['manageReservations'],
        'basicCapacity': value['basicCapacity'],
        'advancedSettings': value['advancedSettings'],
        'customNotifications': value['customNotifications'],
        'whatsappNotifications': value['whatsappNotifications'],
        'customPage': value['customPage'],
        'insurancePolicies': value['insurancePolicies'],
        'analytics': value['analytics'],
    };
}

